import JSZip from "jszip"; // Use JSZip for zipping files
import { saveAs } from "file-saver"; // FileSaver.js for saving files
import { getDocDataByRef } from "../../models/DataFunctions";

const downloadPhotos = async (documentref, nom) => {
  try {
    // Get folder object from reference
    const documentData = await getDocDataByRef(documentref);

    // Get the photos field which contains the photo information
    const photos = documentData?.photos || [];

    // Initialize a list to store photo URLs and filenames
    const photosList = [];

    // Extract photo URL and filename from each document in the photos list
    for (const photoRef of photos) {
      const photo = await getDocDataByRef(photoRef);

      if (photo?.file) {
        photosList.push({
          storage_path: photo.file.url,
          file_name: photo.file.name,
        });
      }
    }

    // Create a zip file containing all photos
    const zip = new JSZip();

    for (const photoInfo of photosList) {
      // Check if storage_path is not null before making the HTTP request
      if (photoInfo.storage_path) {
        const response = await fetch(photoInfo.storage_path);
        if (response.ok) {
          const photoData = await response.arrayBuffer();
          zip.file(photoInfo.file_name, photoData);
        } else {
          console.error(`Failed to download photo: ${photoInfo.storage_path}`);
        }
      }
    }

    // Generate the zip file
    const zipBlob = await zip.generateAsync({ type: "blob" });

    // Save the zip file using FileSaver.js
    saveAs(zipBlob, `Photos_${nom}.zip`);
  } catch (error) {
    console.error(`Error downloading photos: ${error.message}`);
  } finally {
  }
};

export default downloadPhotos;
